import React, { Component } from "react";

import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Media,
} from "reactstrap";

class ItemDetailTab extends Component {
  constructor(props) {
    super(props);
    this.toggleTab = this.toggleTab.bind(this); //Function created to switch between additional tabs
    this.state = {
      description: props.longdescription,
      additionalInfo:
        props.additionalInfo == []
          ? [
            {
              name: "",
              text: "",
            },
          ]
          : props.additionalInfo,
      activeTab: 1,
      stockInfo:
        props.stockInfo == []
          ? [
            {
              name: "",
              text: "",
            },
          ]
          : props.stockInfo,
      stockDetails: props.stockDetails || [],
    };
  }

  toggleTab = (tab) => {
    //Function created to switch between additional tabs
    if (this.state.activeTab !== tab) this.setState({ activeTab: tab });
    this.forceUpdate(); //Sometimes the change happened but will not render, to resolve the issue this method is called
  };

  shouldComponentUpdate(nextProps, nextState) {
    //The component needs to be updated when user switch between items: matrix options
    //console.log('nextProps',nextProps)
    if (this.state.description != nextProps.longdescription) {
      this.setState({ description: nextProps.longdescription });
      // this.forceUpdate()
      return true;
    } else if (this.state.additionalInfo != nextProps.additionalInfo) {
      this.setState({ additionalInfo: nextProps.additionalInfo });
      //this.forceUpdate()
      return true;
    } else if (this.state.stockDetails != nextProps.stockDetails) {
      this.setState({ stockDetails: nextProps.stockDetails });
      //this.forceUpdate()
      return true;
    } else {
      return true;
    }
  }

  render() {
    return (
      <section className="mt-5">
        <Container>
          <Nav tabs className="flex-column flex-sm-row">
            {/* <NavItem>
              <NavLink
                className={`detail-nav-link ${
                  this.state.activeTab === 1 ? "active" : ""
                }`}
                onClick={() => this.toggleTab(1)}
                style={{ cursor: "pointer" }}
              >
                Description
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`detail-nav-link ${
                  this.state.activeTab === 2 ? "active" : ""
                }`}
                onClick={() => this.toggleTab(2)}
                style={{ cursor: "pointer" }}
              >
                Additional Information
              </NavLink>
            </NavItem> */}
            <NavItem>
              <NavLink
                className={`detail-nav-link ${this.state.activeTab === 1 ? "active" : ""
                  }`}
                onClick={() => this.toggleTab(1)}
                style={{ cursor: "pointer" }}
              >
                Stock Information
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent className="py-4" activeTab={this.state.activeTab}>
            {/* <TabPane className="px-3" tabId={1}>
              <Row>
                <Col
                  md="7"
                  dangerouslySetInnerHTML={{ __html: this.state.description }}
                />
              </Row>
            </TabPane> */}
            {/* <TabPane tabId={2}>
              <Row>
                <Col md="12">
                  <table className="table text-sm">
                    {this.state.additionalInfo.map((infoBlock, index) => (
                      <tbody key={index}>
                        <tr>
                          <th className="font-weight-normal border-0">
                            {infoBlock.name}
                          </th>
                          <td className="text-muted border-0">
                            {infoBlock.text.replace(/,/g, ", ")}
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </Col>
              </Row>
            </TabPane> */}
            <TabPane tabId={1}>
              <Row>
                <Col md="12">
                  <table className="table text-sm">
                    <thead>
                      <tr>
                        <th className="font-weight-normal border-0">Item</th>
                        <th className="font-weight-normal border-0">Stock Details</th>
                      </tr>
                    </thead>
                    <tbody >
                      {this.state.stockDetails.map((details, index) => (
                        <tr key={index}>
                          <td className="text-muted">{details.name}</td>
                          <td className="text-muted">
                            {details.details.map((each, index) => (
                              <div key={index} >
                                {each.name}:  {each.text.replace(/,/g, ", ")}
                              </div>
                            ))}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </Container>
      </section >
    );
  }
}
export default ItemDetailTab;
